import {Injectable} from "@angular/core";
import { Data } from "@angular/router";
import {DataResponse, ListDataResponse} from "src/app/models/http.models";
import { Observable, Observer } from "rxjs";
import {BaseApiService} from "./_baseApiService";
import {AnagraficaDto} from "../../models/anagrafica.models";
import {RegistrationRequest} from "../../models/registrazione.models";
import {AplDto, EsperienzaLavoroDto, MansioniDto} from "../../models/lavoro.models";
import {SharedEnumModelKeyValue} from "../../models/shared.models";

@Injectable()

export class WorkService extends BaseApiService{

  public getWorkExperience(idAnagraficaUtente : number):Observable<DataResponse<EsperienzaLavoroDto>>{
    return this.httpService.get(`PortalsLavoro/GetEsperienzeLavorative?idAnagraficaUtente=`+ idAnagraficaUtente);
  }

  public getOccupationStateList():Observable<DataResponse<SharedEnumModelKeyValue>>{
    return this.httpService.get(`PortalsLavoro/GetStatoOccupazioneList`);
  }

  public getTaskByWorkExperienceId(idAnagraficaUtenteEspProf : number):Observable<DataResponse<MansioniDto>>{
    return this.httpService.get(`PortalsLavoro/GetMansioniEsperienza?idAnagraficaUtenteEspProf=`+idAnagraficaUtenteEspProf);
  }

  public getAplList():Observable<DataResponse<AplDto>>{
    return this.httpService.get(`PortalsLavoro/GetAgenzieAplList`);
  }

  public getTaskAutocomplete(description : string):Observable<DataResponse<MansioniDto>>{
    return this.httpService.get(`PortalsLavoro/RicercaMansioni?nome=`+description);
  }

  public workExperienceUpsert(model: EsperienzaLavoroDto):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsLavoro/AnagraficaUtenteEspProfUpdate`, model);
  }

  public workExperienceDelete(idWork : number): Observable<DataResponse<Response>>{
    return this.httpService.delete(`PortalsLavoro/AnagraficaUtenteEsperienzeLavorativeDelete?idAnagraficaUtenteEspProf=`+idWork);
  }


}
